module.exports = __webpack_public_path__ + "img/sg.d4dba61c.svg";